/* Buy panel: gallery arrows, quantity stepper and pack choice. The panel works without this file. */
(function () {
  'use strict';

  /* Arrows step through the gallery by pressing the matching thumbnail, which theme.js already drives. */
  function initArrows(section) {
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-dot]'));
    if (!thumbs.length) return;
    function current() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    function go(step) { thumbs[(current() + step + thumbs.length) % thumbs.length].click(); }
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  /* The stepper and the pack tiles both drive the one quantity input. */
  function initQuantity(section) {
    var input = section.querySelector('[data-qty-input]');
    if (!input) return;
    var packs = Array.prototype.slice.call(section.querySelectorAll('[data-pack-qty]'));
    var wrap = section.querySelector('[data-qty-wrap]');
    var totalEl = section.querySelector('[data-qty-total]');
    var minus = section.querySelector('[data-qty-step="-1"]');
    var plus = section.querySelector('[data-qty-step="1"]');
    var format = section.getAttribute('data-money-format') || 'A${{amount}}';
    function money(cents) { return format.replace('{{amount}}', (cents / 100).toFixed(2)); }

    /* The pack with the most holders that the quantity reaches sets the discount, the same as the
       automatic discounts in Shopify. The theme only shows it; Shopify applies it at checkout. */
    function discountFor(n) {
      var off = 0, best = 0;
      packs.forEach(function (r) {
        var q = parseInt(r.getAttribute('data-pack-qty'), 10), d = parseInt(r.getAttribute('data-pack-off'), 10) || 0;
        if (q <= n && q >= best && d > 0) { best = q; off = d; }
      });
      return off;
    }
    function showTotal(n) {
      if (!wrap || !totalEl) return;
      var unit = parseInt(wrap.getAttribute('data-unit-price'), 10);
      if (!unit) { totalEl.textContent = ''; return; }
      var full = unit * n, off = discountFor(n), now = Math.floor(full * (100 - off) / 100);
      totalEl.textContent = '';
      totalEl.appendChild(document.createTextNode(wrap.getAttribute('data-total-label') + ' ' + money(now)));
      if (off > 0) {
        var was = document.createElement('s');
        was.textContent = money(full);
        totalEl.appendChild(document.createTextNode(' '));
        totalEl.appendChild(was);
        var note = document.createElement('span');
        note.className = 'buy__qty-note';
        note.textContent = wrap.getAttribute('data-discount-note');
        totalEl.appendChild(note);
      }
    }
    function syncPacks() {
      var n = parseInt(input.value, 10);
      packs.forEach(function (r) { r.checked = parseInt(r.getAttribute('data-pack-qty'), 10) === n; });
    }
    function set(n) {
      var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 99;
      input.value = Math.min(max, Math.max(min, n || min));
      var v = parseInt(input.value, 10);
      if (minus) minus.disabled = v <= min;
      if (plus) plus.disabled = v >= max;
      syncPacks();
      showTotal(v);
    }
    section.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { set(parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-step'), 10)); });
    });
    input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
    packs.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) set(parseInt(r.getAttribute('data-pack-qty'), 10)); });
    });
    var start = packs.filter(function (r) { return r.checked; })[0];
    set(start ? parseInt(start.getAttribute('data-pack-qty'), 10) : 1);
  }

  function initAll(root) {
    root.querySelectorAll('[data-product-section]').forEach(function (section) {
      if (section.hasAttribute('data-buy-panel')) return;
      section.setAttribute('data-buy-panel', '');
      initArrows(section);
      initQuantity(section);
    });
  }

  function init() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
